import { assertNotNull } from '../../helpers/nullHelpers';
import { TechnologyTypeCode } from '../shared/technologyTypeCode';
import { BillOfMaterialsItemFormModel } from './billOfMaterialsItemFormModel';

export type CreateUpdateBillOfMaterialsItemDto = {
  billOfMaterialsItemId: number | null;
  technologyTypeCode: TechnologyTypeCode;
  partId: number;
  displayIndex: number;
  quantity: number;
  isDeleted: boolean;
};

export const mapBillOfMaterialsItemFormModelToDto = (
  formModel: BillOfMaterialsItemFormModel,
  index: number,
  technologyTypeCode: TechnologyTypeCode,
): CreateUpdateBillOfMaterialsItemDto => ({
  billOfMaterialsItemId: formModel.billOfMaterialsItemId,
  technologyTypeCode,
  partId: assertNotNull(formModel.partId),
  displayIndex: index,
  quantity: Number(formModel.quantity),
  isDeleted: formModel.isDeleted,
});
